import React, { useMemo } from 'react';
import { IUserGroup } from '../../apiHooks/userApi.types';
import GroupListItem from '../atoms/GroupListItem';
import SearchModalComboboxOption from '../atoms/SearchModalComboboxOption';
import clsx from 'clsx';
import config from '../../config';

interface IProps {
    groups: IUserGroup[];
    isLoading: boolean;
    query: string;
}

export default function SearchModalGroupsTab(props: IProps) {
    const { groups, isLoading, query } = props;

    const filteredGroups = useMemo(() => {
        const searchLower = query.toLowerCase();
        const scored = groups
            .map((group) => {
                const handle = group.account.handle.toLowerCase();
                const displayName = group.account.display_name.toLowerCase();
                const description = group.account.description?.toLowerCase() ?? '';

                let score = 0;
                if (handle === searchLower) score = 5;
                else if (displayName === searchLower) score = 4;
                else if (handle.includes(searchLower)) score = 3;
                else if (displayName.includes(searchLower)) score = 2;
                else if (description.includes(searchLower)) score = 1;

                return { group, score };
            })
            .filter((entry) => entry.score > 0);

        scored.sort((a, b) => b.score - a.score);
        return scored.map((entry) => entry.group);
    }, [groups, query]);

    const showViewMore = isLoading || filteredGroups.length > 5;
    const viewMorePath = '/settings/groups/';

    return (
        <li className='p-2'>
            <div className='mb-2'>
                {isLoading
                    ? Array.from({ length: 5 }).map((_, index) => (
                          <GroupListItem key={index} group={null} asLink={false} className='px-3 select-none' />
                      ))
                    : filteredGroups.slice(0, 5).map((group) => {
                          const path = `/${config.resourcePrefix}${group.account.handle}/`;

                          return (
                              <SearchModalComboboxOption path={path} key={group.account.uuid}>
                                  <GroupListItem group={group} asLink={false} className='px-3 select-none' />
                              </SearchModalComboboxOption>
                          );
                      })}
            </div>
            {!isLoading && filteredGroups.length === 0 && (
                <p className='px-3 py-8 text-center text-sm text-gray-500 dark:text-gray-400'>
                    No groups found for "{query}"
                </p>
            )}
            {showViewMore && (
                <SearchModalComboboxOption path={viewMorePath} disableFocusStyling={isLoading}>
                    <p
                        className={clsx(
                            'px-3 py-2 text-center text-sm text-cyan-800',
                            isLoading ? '' : 'group-data-[focus]:text-white',
                        )}
                    >
                        View more groups
                        {!isLoading && filteredGroups.length > 5 ? ` (${filteredGroups.length} total)` : null}
                    </p>
                </SearchModalComboboxOption>
            )}
        </li>
    );
}
